import SelectedFilters from "./selectedfilters.js";
import DataService from "./dataservice.js";
import FilterValues from "./filtervalues.js";
import { prodListValues } from './shared.js';

const advancedSearchUrl = document.getElementById('QueryUrl');

class UpdateFilterUrl {
    update(filterValues, prodListValues, updatePageNumber, updateUrl, forceGetProducts) {
        if (typeof (updateUrl) === 'undefined') updateUrl = true;
        if (typeof (forceGetProducts) === 'undefined') forceGetProducts = false;

        const pathName = this.urlPath();

        var newPath = this.updatedPriceFilterRouteParam(filterValues.getPriceFilter()) +
            this.updatedColorFilterRouteParam(filterValues.getColorFilter()) +
            this.updatedRatingFilterRouteParam(filterValues.getRatingFilter()) +
            this.updatedProductQuantityFilterRouteParam(filterValues.getProductQuantityFilter()) +
            this.updatedProdTimeRouteParam(filterValues.getProdTimeFilter()) +
            this.updatedImprintLocationCountRouteParam(filterValues.getImprintLocationCountFilter()) +
            this.updatedImprintColorCountRouteParam(filterValues.getImprintColorCountFilter()) +
            this.updatedTagFilterRouteParam(filterValues.getTagFilter());

        if (filterValues.getColorFilter().length === 0 && filterValues.getRatingFilter().length === 0 && filterValues.getProdTimeFilter().length === 0 && filterValues.getTagFilter().length === 0 &&
            filterValues.getPriceFilter().length === 0 && filterValues.getSubSearchFilter().length === 0 && filterValues.getProductQuantityFilter().length === 0 &&
            filterValues.getImprintLocationCountFilter().length === 0 && filterValues.getImprintColorCountFilter().length === 0) {
            SelectedFilters.removeAllFromSelectedFilter();
        }

        // If filtering is applied then set the page to the beginning in case the number of pages decreases.
        if (updatePageNumber !== true) {
            filterValues.addPageNumber(1);
        }

        newPath += this.updatedFilterQueryString(filterValues.getPageNumber(), prodListValues.sortMap, filterValues.getSortFilter(), filterValues.getSubSearchFilter(), filterValues.getPageSize());

        if (!forceGetProducts && window.location.pathname + window.location.search === pathName + newPath) {
            return;
        }

        this.updateCanonicalUrl(newPath);

        newPath = pathName + newPath;

        DataService.getProducts(newPath, updateUrl, newPath);
    };

    updateCanonicalUrl(path) {
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = this.getBaseUrl(canonical.href) + path;
        }

        const amp = document.querySelector('link[rel="amphtml"]');
        if (amp !== null) {
            amp.href = this.getBaseUrl(amp.href) + path;
        }
    };

    getBaseUrl(url) {
        const matches = prodListValues.paramPattern.exec(url);
        var baseUrl = '';

        if (matches !== null) {
            baseUrl = url.slice(0, matches.index);
        } else if (url.indexOf('?') >= 0) {
            baseUrl = url.slice(0, url.indexOf('?'));
        } else {
            baseUrl = url;
        }

        return baseUrl;
    };

    updatedPriceFilterRouteParam(priceRange) {
        var priceFilter = '';

        if (priceRange.length > 1) {
            var priceMin = priceRange[0];
            var priceMax = priceRange[1];
            priceFilter = '/p/' + (priceMin * 100).toFixed() + '-' + (priceMax * 100).toFixed();
        }

        return priceFilter;
    };

    updatedColorFilterRouteParam(colors) {
        var colorFilters = '';
        if (colors.length) {
            colorFilters = '/c/' + colors.join('-');
        }
        return colorFilters;
    };

    updatedRatingFilterRouteParam(ratings) {
        var ratingFilters = '';
        if (ratings.length) {
            ratingFilters = '/r/' + ratings.join('-');
        }
        return ratingFilters;
    };

    updatedProductQuantityFilterRouteParam(productQuantity) {
        var productQuantityFilter = '';
        if (productQuantity.length) {
            productQuantityFilter = '/mq/' + productQuantity;
        }
        return productQuantityFilter;
    };

    updatedProdTimeRouteParam(prodTimes) {
        var timeFilter = '';
        if (prodTimes.length) {
            timeFilter = '/s/' + prodTimes.join('-');
        }
        return timeFilter;
    };

    updatedImprintLocationCountRouteParam(imprintLocationCounts) {
        var imprintLocationCountFilter = '';
        if (imprintLocationCounts.length) {
            imprintLocationCountFilter = '/l/' + imprintLocationCounts.join('-');
        }
        return imprintLocationCountFilter;
    };

    updatedImprintColorCountRouteParam(imprintColorCounts) {
        var imprintColorCountFilter = '';
        if (imprintColorCounts.length) {
            imprintColorCountFilter = '/m/' + imprintColorCounts.join('-');
        }
        return imprintColorCountFilter;
    };

    updatedTagFilterRouteParam(tags) {
        var tagFilter = '';

        if (tags.length) {
            tagFilter = '/t/' + tags.join('-');
        }
        return tagFilter;
    };

    updatedFilterQueryString(pageNo, sortMap, sort, subSearch, pageSize) {
        var newQueryString = '?';

        if (advancedSearchUrl && advancedSearchUrl.value) {
            newQueryString += advancedSearchUrl.value + '&';
        }

        if (pageNo && parseInt(pageNo) !== 1) {
            newQueryString += 'page=' + pageNo + '&';
        }

        if (pageSize && parseInt(pageSize) !== FilterValues.getDefaultPageSize()) {
            newQueryString += 'PS=' + pageSize + '&';
        }

        if (sort && sort !== FilterValues.getDefaultSort()) {
            for (var i = 0; i < sortMap.length; i++) {
                if (sortMap[i].v.search(new RegExp(sort, 'i')) > -1) {
                    newQueryString += sortMap[i].q + '&';
                    break;
                }
            }
        }

        if (subSearch) {
            newQueryString += 'ss=' + subSearch + '&';
        }

        return newQueryString.substr(0, newQueryString.length - 1);
    };

    updatePageSize(pageSize) {
        const currentUrl = window.location.href;
        const pageSizeQueryString = 'PS=' + pageSize;
        const newUrl = currentUrl + (currentUrl.indexOf('?') > -1 ? '&' : '?') + pageSizeQueryString;

        history.replaceState({ title: document.getElementById('BaseTitle').value, keywords: document.getElementById('BaseKeywords').value, description: document.getElementById('BaseDescription').value }, '', newUrl);
    };

    urlPath() {
        const currentUrl = window.location.href;
        var baseUrl = '';

        if (document.getElementById('FilterFriendlyUrl').value.length > 0) {
            baseUrl = document.getElementById('FilterFriendlyUrl').value;
        } else {
            baseUrl = this.getBaseUrl(currentUrl);
        }
        const urlArray = currentUrl.split('/');
        const prot = urlArray[0];
        const host = urlArray[2];
        const url = prot + '//' + host;

        return baseUrl.replace(url, '');
    };
}

export default new UpdateFilterUrl();